// extracted by mini-css-extract-plugin
export default {"activity-selector":"styles-module_activity-selector---NWiyO"};